var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_582_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24994 8.00006H1.74994C0.784973 8.00006 0 7.21509 0 6.24994V1.74994C0 0.784973 0.784973 0 1.74994 0H9.24994C10.2151 0 11.0001 0.784973 11.0001 1.74994V6.24994C11.0001 7.21509 10.2151 8.00006 9.24994 8.00006ZM1.74994 1.5C1.61206 1.5 1.5 1.61206 1.5 1.74994V6.24994C1.5 6.388 1.61206 6.50006 1.74994 6.50006H9.24994C9.388 6.50006 9.50006 6.388 9.50006 6.24994V1.74994C9.50006 1.61206 9.388 1.5 9.24994 1.5H1.74994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24994 24.0001H1.74994C0.784973 24.0001 0 23.2151 0 22.2501V11.7501C0 10.785 0.784973 10 1.74994 10H9.24994C10.2151 10 11.0001 10.785 11.0001 11.7501V22.2501C11.0001 23.2151 10.2151 24.0001 9.24994 24.0001ZM1.74994 11.5C1.61206 11.5 1.5 11.6121 1.5 11.7501V22.2501C1.5 22.388 1.61206 22.5001 1.74994 22.5001H9.24994C9.388 22.5001 9.50006 22.388 9.50006 22.2501V11.7501C9.50006 11.6121 9.388 11.5 9.24994 11.5H1.74994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2501 23.9999H14.7501C13.7849 23.9999 12.9999 23.215 12.9999 22.25V17.75C12.9999 16.7849 13.7849 15.9999 14.7501 15.9999H22.2501C23.215 15.9999 24 16.7849 24 17.75V22.25C24 23.215 23.215 23.9999 22.2501 23.9999ZM14.7501 17.4999C14.612 17.4999 14.4999 17.6119 14.4999 17.75V22.25C14.4999 22.3879 14.612 22.4999 14.7501 22.4999H22.2501C22.3879 22.4999 22.5 22.3879 22.5 22.25V17.75C22.5 17.6119 22.3879 17.4999 22.2501 17.4999H14.7501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2501 14.0001H14.7501C13.7849 14.0001 12.9999 13.2151 12.9999 12.2499V1.74994C12.9999 0.784973 13.7849 0 14.7501 0H22.2501C23.215 0 24 0.784973 24 1.74994V12.2499C24 13.2151 23.215 14.0001 22.2501 14.0001ZM14.7501 1.5C14.612 1.5 14.4999 1.61206 14.4999 1.74994V12.2499C14.4999 12.388 14.612 12.5001 14.7501 12.5001H22.2501C22.3879 12.5001 22.5 12.388 22.5 12.2499V1.74994C22.5 1.61206 22.3879 1.5 22.2501 1.5H14.7501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_582_2750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhite);
export default __webpack_public_path__ + "static/media/Dashboard_White.cb68d0203c38c4918f26f6e7fd2d6e05.svg";
export { ForwardRef as ReactComponent };